export const ADMIN_PORTAL_VARIANT = "admin-portal";

export const EMPTY_VALUE = "-";
